<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('action.inventorySearchSchedule')]"></breadcrumb>
    </div>
    <div class="search center">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-autocomplete
            size="small"
            v-model.trim="searchForm.productNo"
            :fetch-suggestions="querySearchProductNo"
            :trigger-on-focus="false"
            style="width: 100%"
            @select="handleSelectProductNo"
            :placeholder="$t('product.productNo')"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.productNo }}</div>
              <span class="addr">{{ item.productNoAlias }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item :prop="'color'">
          <el-autocomplete
            size="small"
            v-model.trim="searchForm.color"
            :fetch-suggestions="querySearchColor"
            style="width: 100%"
            @select="handleSelectColor"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-autocomplete
            size="small"
            v-model.trim="searchForm.size"
            :fetch-suggestions="querySearchSize"
            style="width: 100%"
            @select="handleSelectSize"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <!-- <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item> -->
        <div class="mgt10">
          <el-button type="primary" size="small" native-type="submit"
            >查询</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <!-- <div v-if="!searchFormDF" class="noData">请输入查询条件</div> -->
      <vxe-table
        :data="records"
        :sort-config="{ remote: true }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="150"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div>
              <state-label :state="row.workflowState">
                {{ $t("rentStates." + row.workflowState) }}
              </state-label>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}

            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('rentItem.price')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.price | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="inventory"
          :title="$t('inventory.inventoryInfo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span
              v-if="
                row.inventory != null &&
                row.inventory.inventoryShelfs.length != 0
              "
            >
              <div
                v-for="(item, index) of row.inventory.inventoryShelfs"
                :key="index"
                class="font10"
              >
                {{ item.shelfName }}：{{ item.quantity }}
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="startAt"
          :title="$t('rent.rentAt')"
          width="130"
        >
          <template v-slot="{ row }">
            <span v-if="row.rent != null">
              {{ row.rent.startAt }} ～
              {{ row.rent.endAt }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.rent != null">
              {{ row.rent.customerName }}
              <div class="font10">{{ row.rent.shopName }}</div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
      </vxe-table>
      <!-- <vxe-table
        v-if="searchFormDF"
        :data="records"
        :span-method="mergeMethod"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="calculateBgColor"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isMerge">
              <thumbnail :images="row.images" />
            </span>
            <div v-else>
              <span class="float-left">
                <span class="mgr5">
                  {{ row.serialNo }}
                </span>
                <span class="font10 mgr5">
                  {{ $t("text.total") }}:
                  {{ row.amount | currency }}
                </span>

                <span class="font10 mgr5">
                  {{ $t("bargain.receive") }}:
                  {{ row.payAmount | currency }}
                </span>

                <span v-if="row.differAmount > 0" class="font10 red mgr5">
                  {{ $t("bargain.differ") }}:
                  {{ row.differAmount | currency }}
                </span>
                <span v-if="row.differAmount == 0" class="font10 green mgr5">
                  {{ $t("bargain.settled") }}
                </span>
                <span v-if="row.differAmount < 0" class="font10 orange">
                  {{ $t("bargain.leave") }}:{{ -row.differAmount | currency }}
                </span>
                {{ $t("rent.rentAt") }}：{{ row.startAt }} ～
                {{ row.endAt }}
              </span>

              <span class="float-right font10">
                {{ $t("menu.customers") }}：{{ row.customerName }}&nbsp;

                {{ $t("text.owner") }}:{{ row.ownerName }} {{ row.shopName }}
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="150"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div>
              <state-label :state="row.workflowState">
                {{ $t("rentStates." + row.workflowState) }}
              </state-label>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}

            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('rentItem.price')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.price | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
      </vxe-table> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Product from "@/api/product.js";
import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Rent from "@/api/rent.js";

export default {
  mixins: [page, table.search],
  components: {},
  data() {
    return {
      Util: Util,
      searchForm: {
        productNo: null,
        color: null,
        size: null,
      },
      productNoColors: [],
      productNoSizes: [],
      records: [],
      searchFormDF: false,
      loading: false,
    };
  },
  created() {
    const self = this;
    axios.all([Size.findByTenantId(), Color.findByTenantId()]).then(
      axios.spread(function (sizes, colors) {
        if (sizes.status === 200) {
          self.sizes = sizes.data;
        } else {
          self.sysError();
        }
        if (colors.status === 200) {
          self.colors = colors.data;
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    search() {
      const self = this;
      if (
        self.searchForm.productNo == null ||
        self.searchForm.productNo == ""
      ) {
        this.$message({
          message: self.$t("rules.required", [self.$t("product.productNo")]),
          type: "warning",
        });
        return;
      }
      self.records = [];
      self.loading = true;
      Rent.searchSchedule(self.searchForm).then(function (res) {
        if (res.status == 200) {
          if (res.data.length != 0) {
            self.records = res.data;
            // self.recordsDecorate(res.data);
          }
          self.searchFormDF = true;
        } else {
          self.sysError();
        }
        self.loading = false;
      });
    },
    // recordsDecorate(records) {
    //   this.records = this.buildTableData(records);
    //   this.mergeCells = this.buildMergeCells(records);
    // },
    // mergeMethod({ rowIndex, columnIndex }) {
    //   const mergeCells = this.mergeCells;
    //   for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
    //     const { row, col, rowspan, colspan } = mergeCells[mIndex];
    //     if (row === rowIndex && col === columnIndex) {
    //       return { rowspan, colspan };
    //     }
    //     if (
    //       rowIndex >= row &&
    //       rowIndex < row + rowspan &&
    //       columnIndex >= col &&
    //       columnIndex < col + colspan
    //     ) {
    //       return { rowspan: 0, colspan: 0 };
    //     }
    //   }
    //   return { rowspan: 1, colspan: 1 };
    // },
    // buildTableData(records) {
    //   let rs = [];
    //   records.forEach((record) => {
    //     let bRent = {
    //       isMerge: true,
    //       id: record.id,
    //       serialNo: record.serialNo,
    //       customerId: record.customerId,
    //       customerName: record.customerName,
    //       customerCountry: record.customerCountry,
    //       customerProvince: record.customerProvince,
    //       customerCity: record.customerCity,
    //       customerAddress: record.customerAddress,
    //       customerPhone: record.customerPhone,
    //       customerZipcode: record.customerZipcode,
    //       remark: record.remark,
    //       cancelAt: record.cancelAt,
    //       cancelReason: record.cancelReason,
    //       ownerId: record.ownerId,
    //       ownerName: record.ownerName,
    //       shopId: record.shopId,
    //       shopName: record.shopName,
    //       createAt: record.createAt,
    //       tenantId: record.tenantId,
    //       startAt: record.startAt,
    //       endAt: record.endAt,
    //       customerSource: record.customerSource,
    //       amount: record.amount,
    //       payAmount: record.payAmount,
    //       differAmount: record.differAmount,
    //       rentItems: record.rentItems,
    //       payments: record.payments,
    //     };
    //     rs.push(bRent); //将bargain的数据转换到格式，放到数据列表
    //     // record.rentItems.forEach((item) => {
    //     //   rs.push(item);
    //     // });
    //     for (const item of record.rentItems) {
    //       Vue.set(item, "_rent", bRent);
    //       rs.push(item);
    //     }
    //   });
    //   return rs;
    // },
    // buildMergeCells(rents) {
    //   let mcs = [];
    //   for (let i = 0, rowIdx = 0; i < rents.length; i++) {
    //     mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 7 });
    //     rowIdx = rowIdx + rents[i].rentItems.length + 1;
    //   }
    //   return mcs;
    // },
    // calculateBgColor({ row, rowIndex }) {
    //   return row.isMerge ? "light-blue-bg" : "";
    // },

    // 货号
    querySearchProductNo(queryString, cb) {
      const self = this;
      //
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        self.products = res.data;
        if (self.products.length !== 0) {
          for (const p of self.products) {
            Vue.set(p, "value", p.productNo);
          }
        }
        cb(self.products);
      });
    },
    handleSelectProductNo(item) {
      const self = this;
      self.searchForm.productNo = item.productNo;
      self.productNoColors = item.colors;
      self.productNoSizes = item.sizes;
    },
    // 颜色
    querySearchColor(queryString, cb) {
      const colors =
        this.productNoColors.length !== 0
          ? this.productNoColors.map((pc) => {
              return { value: pc };
            })
          : this.colors.map((c) => {
              return { value: c.name };
            });
      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor() {
      this.searchForm.color = Util.jyTrim(this.searchForm.color);
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      let sizes = [];
      if (self.productNoSizes.length !== 0) {
        sizes = this.productNoSizes.map((pc) => {
          return { value: pc };
        });
      } else {
        sizes = this.sizes.map((c) => {
          return { value: c.name, explain: c.explain };
        });
      }
      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize() {
      const self = this;
      self.searchForm.size = Util.jyTrim(self.searchForm.size);
    },
  },
};
</script>
<style scoped>
</style>
